import React from 'react';
import {t} from 'ttag';
import {Box, Card, CardContent, CardHeader, Chip, Grid2, Typography} from '@mui/material';
import {IInvoice} from '../../../store/apis/interfaces/invoice';
import {styles, InvoiceReceipt, InvoiceInformation, InvoiceItems} from '@invoice-system';

interface InvoiceDetailsProps {
  data: IInvoice;
}

export const InvoiceDetails = ({data}: InvoiceDetailsProps) => {
  return (
    <Card variant={'outlined'} sx={{height: 'auto'}}>
      <CardHeader
        sx={{backgroundColor: 'rgba(249, 250, 251, 1)'}}
        title={
          <Box display={'flex'} justifyContent={'space-between'} flexDirection={{xs: 'column', md: 'row'}} alignItems={{xs: 'start', md: 'center'}} gap={1}>
            <Typography
              sx={{...styles.subtitle, color: 'black', fontSize: '1.125rem'}}
            >{t`Invoice` + ` ${data?.docId || 'N/A'}`}</Typography>
            <Box display={'flex'} gap={1}>
              <Chip size={'small'} sx={styles.chip('info')} label={t`Sequence` + ': ' + (data?.sequence || 'N/A')} />
              <Chip size={'small'} sx={styles.chip(!data?.docId ? 'error' : undefined)} label={!data?.docId ? t`SAP: NOT REGISTERED` : t`SAP: REGISTERED`} />
            </Box>
          </Box>
        }
      />
      <CardContent>
        <Grid2 container spacing={{xs: 3, md: 1}}>
          <Grid2 size={{xs: 12, md: 6}}>
            <Typography variant={'body1'} fontFamily={'OpenSansMedium'} color={'black'}>
              {t`Invoice Information`}
            </Typography>
            <InvoiceInformation data={data}/>
          </Grid2>
          <Grid2 size={{xs: 12, md: 6}} display={'flex'} flexDirection={'column'} justifyContent={'right'}>
            <Typography variant={'body1'} fontFamily={'OpenSansMedium'} color={'black'} textAlign={{xs: 'left', md: 'right'}}>
              {t`Invoice Receipt`}
            </Typography>
            <InvoiceReceipt data={data}/>
          </Grid2>
          <Grid2 size={{xs: 12}} overflow={'auto'} mt={{xs: 0, md: 2}}>
            <Typography variant={'body1'} fontFamily={'OpenSansMedium'} color={'black'} mb={1.5}>
              {t`Invoice Items`}
            </Typography>
            <InvoiceItems data={data}/>
          </Grid2>
        </Grid2>
      </CardContent>
    </Card>
  )
}
